import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import fin from './fin.json';
import fr from './fr.json';
import swe from './swe.json';

const resources = {
    en: {
        translation: en,
    },
    fi: {
        translation: fin,
    },
    fr: {
        translation: fr,
    },
    sv: {
        translation: swe,
    },
};

i18next.use(initReactI18next).init({
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    lng: navigator.language,
    resources,
});

export default i18next;